import { assertBoolean } from '../../validators';
import type { CommonAttributeSettings } from './common';
import { createAttributeSetter, DEFAULT_ATTRIBUTE_SETTINGS, defineMetadata } from './common';

export const BOOLEAN_ATTRIBUTE_TYPE = 'booleanAttributeType';

/**
 * Creates an attribute decorator used to describe an boolean property. This will enforce a boolean
 * value of true or false.
 */
export function BooleanAttribute(settings: Partial<CommonAttributeSettings> = {}) {
    settings = { ...DEFAULT_ATTRIBUTE_SETTINGS, ...settings };
    const validator = assertBoolean;
    return function <This>(
        { get, set }: ClassAccessorDecoratorTarget<This, boolean>,
        context: ClassAccessorDecoratorContext,
    ): ClassAccessorDecoratorResult<This, boolean> {
        defineMetadata(
            settings,
            BOOLEAN_ATTRIBUTE_TYPE,
            context,
            get as (this: unknown) => unknown,
        );
        return {
            get: function (this: This) {
                return get.call(this);
            },
            set: createAttributeSetter(
                validator,
                get as (this: object) => boolean,
                set as (this: object, value: boolean) => void,
            ) as (this: This, value: boolean) => void,
        };
    };
}
